(function () {
  'use strict';
  if (window.__lcWishlistReady) return;
  window.__lcWishlistReady = true;

  var storageKey = 'laadcentrum:wishlist:v1';
  var language = (document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
  var translations = {
    nl: { title: 'Bewaarde producten', open: 'Bekijk bewaarde producten', label: 'Bewaard', close: 'Sluiten', remove: 'Verwijder', description: 'Je favorieten blijven bewaard in deze browser.', empty: 'Je hebt nog geen producten bewaard.', add: 'Bewaar als favoriet', undo: 'Verwijder uit favorieten' },
    de: { title: 'Merkliste', open: 'Merkliste anzeigen', label: 'Merkliste', close: 'Schließen', remove: 'Entfernen', description: 'Deine Favoriten bleiben in diesem Browser gespeichert.', empty: 'Noch keine Produkte gespeichert.', add: 'Als Favorit speichern', undo: 'Aus Favoriten entfernen' },
    en: { title: 'Saved products', open: 'View saved products', label: 'Saved', close: 'Close', remove: 'Remove', description: 'Favorites are saved in this browser.', empty: 'No products saved yet.', add: 'Save to favorites', undo: 'Remove from favorites' },
    fr: { title: 'Mes favoris', open: 'Voir les favoris', label: 'Favoris', close: 'Fermer', remove: 'Retirer', description: 'Vos favoris sont enregistrés dans ce navigateur.', empty: 'Aucun produit enregistré.', add: 'Ajouter aux favoris', undo: 'Retirer des favoris' }
  };
  var words = translations[language] || translations.nl;
  var handlePattern = /^[a-z0-9][a-z0-9-]{0,150}$/;

  function trimText(value, max) {
    return typeof value === 'string' ? value.trim().slice(0, max) : '';
  }
  function safeProductUrl(value, handle) {
    var fallback = '/products/' + encodeURIComponent(handle);
    try {
      var parsed = new URL(value || fallback, window.location.origin);
      return parsed.origin === window.location.origin ? parsed.pathname + parsed.search : fallback;
    } catch (_) {
      return fallback;
    }
  }
  function safeImageUrl(value) {
    try {
      if (!value) return '';
      var parsed = new URL(value, window.location.href);
      return parsed.protocol === 'https:' && (parsed.hostname === window.location.hostname || parsed.hostname === 'cdn.shopify.com')
        ? parsed.href : '';
    } catch (_) {
      return '';
    }
  }
  function loadSaved() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(raw)) return [];
      var seen = new Set();
      return raw.filter(function (entry) {
        if (!entry || typeof entry.handle !== 'string' || !handlePattern.test(entry.handle) || seen.has(entry.handle)) return false;
        seen.add(entry.handle);
        return true;
      }).slice(0, 80).map(function (entry) {
        return {
          handle: entry.handle,
          title: trimText(entry.title, 220) || entry.handle,
          url: safeProductUrl(entry.url, entry.handle),
          image: safeImageUrl(entry.image)
        };
      });
    } catch (_) {
      return [];
    }
  }
  var saved = loadSaved();
  var launcher;
  var dialog;
  var items;
  var lastDialogTrigger = null;

  function persist() {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(saved));
    } catch (_) {
      // Browser restrictions: favorites still work for this page session.
    }
  }
  function sync() {
    var savedHandles = new Set(saved.map(function (entry) { return entry.handle; }));
    document.querySelectorAll('[data-lc-wishlist-toggle]').forEach(function (button) {
      var isSaved = savedHandles.has(button.getAttribute('data-lc-wishlist-handle'));
      var label = isSaved
        ? (button.getAttribute('data-lc-wishlist-remove-label') || words.undo)
        : (button.getAttribute('data-lc-wishlist-add-label') || words.add);
      button.setAttribute('aria-pressed', String(isSaved));
      button.setAttribute('aria-label', label + ': ' + (button.getAttribute('data-lc-wishlist-title') || ''));
      button.title = label;
    });
    document.querySelectorAll('[data-lc-wishlist-open]').forEach(function (button) {
      button.setAttribute('aria-label', words.open + ' (' + saved.length + ')');
      button.title = words.open;
      var counter = button.querySelector('[data-lc-wishlist-count]');
      if (counter) {
        counter.textContent = String(saved.length);
        counter.hidden = saved.length === 0;
      }
    });
    if (launcher) {
      // Gebruik de header als vaste toegang, zonder een tweede zwevende knop.
      launcher.hidden = saved.length === 0 || !!document.querySelector('[data-lc-wishlist-open]');
      launcher.setAttribute('aria-label', words.open + ' (' + saved.length + ')');
      var count = launcher.querySelector('.lc-wishlist-launcher__count');
      if (count) count.textContent = String(saved.length);
    }
  }
  function makeLink(entry) {
    var link = document.createElement('a');
    link.className = 'lc-wishlist-row__name';
    link.href = safeProductUrl(entry.url, entry.handle);
    link.textContent = entry.title;
    return link;
  }
  function refreshPanel() {
    if (!items) return;
    items.replaceChildren();
    if (!saved.length) {
      var empty = document.createElement('p');
      empty.className = 'lc-wishlist-empty';
      empty.textContent = words.empty;
      items.appendChild(empty);
      return;
    }
    saved.forEach(function (entry) {
      var row = document.createElement('div');
      row.className = 'lc-wishlist-row';
      var media = document.createElement('a');
      media.className = 'lc-wishlist-row__image';
      media.href = safeProductUrl(entry.url, entry.handle);
      if (entry.image) {
        var image = document.createElement('img');
        image.src = safeImageUrl(entry.image);
        image.alt = '';
        image.loading = 'lazy';
        media.appendChild(image);
      }
      var name = makeLink(entry);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'lc-wishlist-row__remove';
      remove.setAttribute('data-lc-wishlist-remove', entry.handle);
      remove.setAttribute('aria-label', words.remove + ': ' + entry.title);
      remove.textContent = words.remove;
      row.append(media, name, remove);
      items.appendChild(row);
    });
  }
  function removeFavorite(handle) {
    saved = saved.filter(function (entry) { return entry.handle !== handle; });
    persist();
    sync();
    refreshPanel();
  }
  function toggleFavorite(button) {
    var handle = button.getAttribute('data-lc-wishlist-handle') || '';
    if (!handlePattern.test(handle)) return;
    if (saved.some(function (entry) { return entry.handle === handle; })) {
      removeFavorite(handle);
      return;
    }
    saved.unshift({
      handle: handle,
      title: trimText(button.getAttribute('data-lc-wishlist-title'), 220) || handle,
      url: safeProductUrl(button.getAttribute('data-lc-wishlist-url'), handle),
      image: safeImageUrl(button.getAttribute('data-lc-wishlist-image'))
    });
    saved = saved.slice(0, 80);
    persist();
    sync();
    refreshPanel();
  }
  function openPanel(trigger) {
    if (!dialog) return;
    lastDialogTrigger = trigger || null;
    refreshPanel();
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }
  function setupUi() {
    if (document.getElementById('lcWishlistDialog')) return;
    launcher = document.createElement('button');
    launcher.type = 'button';
    launcher.className = 'lc-wishlist-launcher';
    launcher.hidden = true;
    launcher.setAttribute('aria-haspopup', 'dialog');
    launcher.setAttribute('aria-controls', 'lcWishlistDialog');
    launcher.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.6 5.6 0 0 0-7.9 0l-.9.9-.9-.9a5.6 5.6 0 0 0-7.9 7.9L12 21l8.8-8.5a5.6 5.6 0 0 0 0-7.9Z"/></svg>' +
      '<span class="lc-wishlist-launcher__label"></span><span class="lc-wishlist-launcher__count">0</span>';
    launcher.querySelector('.lc-wishlist-launcher__label').textContent = words.label;

    dialog = document.createElement('dialog');
    dialog.className = 'lc-wishlist-dialog';
    dialog.id = 'lcWishlistDialog';
    dialog.setAttribute('aria-labelledby', 'lcWishlistHeading');
    dialog.innerHTML = '<div class="lc-wishlist-dialog__head"><h2 id="lcWishlistHeading"></h2><button type="button" class="lc-wishlist-dialog__close" data-lc-wishlist-close aria-label="' + words.close + '">×</button></div><p class="lc-wishlist-dialog__subtext"></p><div class="lc-wishlist-items"></div>';
    dialog.querySelector('#lcWishlistHeading').textContent = words.title;
    dialog.querySelector('.lc-wishlist-dialog__subtext').textContent = words.description;
    items = dialog.querySelector('.lc-wishlist-items');
    document.body.append(launcher, dialog);
    launcher.addEventListener('click', function () {
      openPanel(launcher);
    });
    dialog.querySelector('[data-lc-wishlist-close]').addEventListener('click', function () {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog && typeof dialog.close === 'function') dialog.close();
    });
    dialog.addEventListener('close', function () {
      if (lastDialogTrigger && lastDialogTrigger.isConnected) lastDialogTrigger.focus();
      lastDialogTrigger = null;
    });
  }
  function init() {
    setupUi();
    sync();
    document.addEventListener('click', function (event) {
      var origin = event.target instanceof Element ? event.target : event.target.parentElement;
      if (!origin || !origin.closest) return;
      var headerButton = origin.closest('[data-lc-wishlist-open]');
      if (headerButton) {
        event.preventDefault();
        event.stopPropagation();
        openPanel(headerButton);
        return;
      }
      var heart = origin.closest('[data-lc-wishlist-toggle]');
      if (heart) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        toggleFavorite(heart);
        return;
      }
      var remove = origin.closest('[data-lc-wishlist-remove]');
      if (remove) {
        event.preventDefault();
        removeFavorite(remove.getAttribute('data-lc-wishlist-remove'));
      }
    }, true);
    window.addEventListener('storage', function (event) {
      if (event.key === storageKey || event.key === null) {
        saved = loadSaved();
        sync();
        refreshPanel();
      }
    });
    window.addEventListener('pageshow', sync);
    var queued = false;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && (node.matches('[data-lc-wishlist-toggle], [data-lc-wishlist-open]') || node.querySelector('[data-lc-wishlist-toggle], [data-lc-wishlist-open]'))) {
            if (!queued) {
              queued = true;
              window.requestAnimationFrame(function () { queued = false; sync(); });
            }
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
